module.exports = __webpack_public_path__ + "img/image39.1fcec068.jpg";